import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "shared/hooks/useTranslation";
import { UX_LOADING } from "lib/uxTokens";

interface LoadingStateProps {
    minHeight?: string | number;
    spinnerSize?: number;
    label?: string;
}

export default function LoadingState({
    minHeight = UX_LOADING.sectionMinHeight,
    spinnerSize = UX_LOADING.sectionSpinnerSize,
    label,
}: LoadingStateProps) {
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                minHeight,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1.25,
            }}
        >
            <CircularProgress size={spinnerSize} />
            <Typography variant="body2" color="text.secondary">
                {label ?? t("common.loading")}
            </Typography>
        </Box>
    );
}
